const selectors = {
  COMPOSITE_GROUP: 'ws-composite-group',
  COMPOSITE_ITEM: 'ws-composite-item',
};

export default selectors;
